class ConsoleConstants {
  /**
   * Map of language keys to their display names
   */
  static get LANGUAGE_MAP() {
    return new Map([['python', 'Python'], ['groovy', 'Groovy'], ['scala', 'Scala']]);
  }
}
export default ConsoleConstants;
//# sourceMappingURL=ConsoleConstants.js.map